import React from 'react';
import Nav from './Nav';
import Steps from './Steps';
import axios from 'axios';
import { LoadScript } from '@react-google-maps/api';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import ReactGA from 'react-ga';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ThemeProvider } from '@material-ui/core/styles';
import getThemeFromPrimary from './theme';

const API =  process?.env?.NODE_ENV === 'development' ? 'http://localhost:8001' : '../' ;
const getCookieValue = (key) => {
  const value = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');
  return value ? value.pop() : undefined;
}

const App = () => {
  const [active, setActive] = React.useState(0);
  const [info, setInfo] = React.useState(null);
  const [changeable, setChangeable] = React.useState(false)
  const [organization, setOrganization] = React.useState();
  const [roofs, setRoofs] = React.useState([]);
  const [packages, setPackages] = React.useState([]);
  const [policy, setPolicy] = React.useState('');
  const [theme, setTheme] = React.useState();
  const [trackingId, setTrackingId] = React.useState();
  const [loading, setLoading] = React.useState(true);
  const [ref] = React.useState(/ref=(\w+)/.exec(window.location.search) ? (/ref=(\w+)/.exec(window.location.search)[1] || "LIGHT") : "LIGHT");
  const request = axios.CancelToken.source()

  React.useEffect(() => {
    ReactGA.initialize(trackingId);
  }, [trackingId])
  
  React.useEffect(() => {
    let parseOrg = /organization=(\d+)/.exec(window.location.search)
    if (parseOrg && parseOrg.length > 0) parseOrg = parseOrg[1];
    if (parseOrg) setOrganization(parseInt(parseOrg))
    else setOrganization(1);
  }, [])

  const [state, setState] = React.useState({
    ref: ref,
    accessories: undefined,
    batteries: undefined,
    calculationID: 0,
    calculationKey: 0,
    consumption: {},
    contactInstructions: {},
    copy: 0,
    email: '',
    financing: {},
    geometry: {},
    loadedRoof: 1,
    location: {},
    optimizers: {},
    organization: organization,
    panels: {},
    phone: "",
    products: {},
    removeRoof: 0,
    roof: {},
    sales: {},
    selectedRoof: 1,
    wallbox: undefined,
    zip: "",
  });

  React.useEffect(() => {
    setState({...state, ref})
    console.log({...state, ref});
  }, [ref])



  React.useEffect(() => {
    if (organization) {
      setState({...state, organization: organization})
      axios.get(`${API}/src/Organization/OrganizationAPI.php?action=getOrgDetails&organization=${organization}`)
      .then(res => setPolicy(res.data.privacyPolicy))
      .catch(err => setPolicy(""));
      axios.get(`${API}/packages.php?organization=` + organization, null)
      .then(res => setPackages(res.data))
      .catch(() => setPackages([]))
      axios.get(`${API}/roofs.php?organization=` + organization, null)
      .then(res => setRoofs(res.data))
      .catch(() => setRoofs([]))
      axios.get(`${API}/organization.php?organization=` + organization, null)
      .then(res => {
        setTheme(getThemeFromPrimary(res?.data?.theme || '#7BBD58'))
        setTrackingId(res?.data?.trackingId)
      })
      .catch(() => setTheme(getThemeFromPrimary('#7BBD58')))
      .finally(() => setLoading(false))
    }
  }, [organization])

  React.useEffect(() => {
    const body = new FormData();
    body.append('data', JSON.stringify(state))
    axios.post(`${API}/calculatorBack.php`, body, {
      cancelToken: request.token,
    })
    .then(res => setInfo(res.data))
    .catch(() => void 0)
    return () => {
      request.cancel()
    }
  }, [state])

  React.useEffect(() => {
    if (active > 2) setChangeable(true)
  },[active])

  React.useEffect(() => {
    let cont = true;
    let step = 0;
    if (active === 0 && info) {
      if (cont && info.calculationID) {
        step++;
      } else {
        cont = false;
      }
      if (cont && info && info.front && info.front.location && info.front.location.address && info.front.location.latitude && info.front.location.longitude) {
        step++;
      } else {
        cont = false;
      }
      // eslint-disable-next-line eqeqeq
      if (info && info.front && info.front.geometry && info.front.geometry && info.front.geometry.roofWidth != 0 && info.front.geometry.houseLength != 0) {
        step++;
      } else {
        cont = false;
      }
      if (cont && info && info?.front?.location?.address && getCookieValue('email')) {
        step = 6;
      }
      setActive(step);
      setChangeable(step > 3);
    }
  }, [info])


  return (
      <LoadScript
      loadingElement={<></>}
    googleMapsApiKey="AIzaSyB82dWfcYrFCqYp1XwS20x-1ON2MQ80pCw"
    libraries={["places", "drawing"]}
  >
    <>{loading ? <Box style={{width: "100%", height: "100%", textAlign: "center", marginTop: "40vh"}}><CircularProgress color="#000" /></Box> :
    <ThemeProvider theme={theme}>
    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
    <CssBaseline />
          <Nav changeable={changeable} value={active} handleChange={setActive}/>
          <Steps policy={policy} info={info} next={() => setActive(active + 1)} value={active} organization={organization} state={state} change={setState} packages={packages} roofs={roofs} API={API}/>
      </ThemeProvider>}
    </>
   </LoadScript>)
}

export default App;
